module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-button', {
    attrs: {
      "type": "text",
      "plain": "",
      "icon": "el-icon-edit"
    },
    on: {
      "click": function($event) {
        return _vm.clickEvent()
      }
    }
  }, [_vm._v(_vm._s(_vm.btnCon))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-a4a41f3e"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/myButton/TableUpdateButton.vue
// module id = 1955
// module chunks = 1